<template>
  <el-table :data="tableServerInfo" border>
    <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
    <el-table-column prop="iccid" label="ICCID" align="center">
      <template slot-scope="{row}">
        <span style="color: #4466AD;cursor: pointer;text-decoration: underline;" @click="jumpCardDetails(row.iccid)">{{row.iccid}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="msisdn" label="MSISDN" align="center"></el-table-column>
    <el-table-column prop="companyNameLevel" label="代理商" align="center"></el-table-column>
    <el-table-column prop="showStatus" label="状态" align="center"></el-table-column>
    <el-table-column prop="cardIntegral" label="卡积分" align="center"></el-table-column>
    <el-table-column prop="operationName" label="运营商" align="center"></el-table-column>
    <el-table-column prop="createTime" label="绑卡时间" align="center"></el-table-column>
    <el-table-column prop="expireTime" label="过期时间" align="center"></el-table-column>
  </el-table>
</template>
<script>
import { wxUserBindCardList } from "@/api/api.js";
export default {
  props: {
    userId: {
      type: [String]
    }
  },
  data() {
    return{
      tableServerInfo:[],
    }
  },
  methods: {
    // 状态转换
    inventoryStatusType(status) {
      let obj = {
        1: "库存",
        2: "待激活",
        3: "可测试",
        4: "已激活",
        5: "已停机",
        6: "预销户",
        7: "已销户",
        8: "停机保号",
        9: "已补卡",
      };
      return obj[status];
    },
    // 获取列表的数据
    initData(){
      let params = {
        userId:this.userId
      };
      wxUserBindCardList(params).then(res => {
        if(res.data.code == 200){
          this.tableServerInfo = res.data.data;
          this.tableServerInfo.map((item,index) =>{
            item.ids = index + 1;
            item.cardStatus = this.inventoryStatusType(item.cardStatus);
            item.showStatus = this.inventoryStatusType(item.showStatus);
          })
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    // 跳转到卡详情
    jumpCardDetails(iccid){
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    }
  },
  created() {
    this.initData()
  }
};
</script>

<style scoped lang="less">

</style>


